<template>
  <v-app>
    <Navbar/>
    <div>
      <v-content>
        <v-container grid-list-lg class="view_order">
          <v-layout row wrap>
            <v-flex xs12 md5>
              <v-card>
                <v-card-title><h4>{{ $t('Customer')}} {{ $t('Details')}}</h4></v-card-title>
                <v-divider></v-divider>
                <v-list dense class="pukulist">              
                  <v-list-tile>
                    <v-list-tile-content><b>{{ $t('Customer_name')}}:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.pos_customer_name}}</v-list-tile-content>
                  </v-list-tile>                 
                  <v-list-tile>
                    <v-list-tile-content><b>{{ $t('Phone')}}:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.pos_customer_mobile}}</v-list-tile-content>
                  </v-list-tile>
                 
                </v-list>
                <br><br>
                <v-card-title><h4>{{ $t('Order')}} {{ $t('Details')}}</h4></v-card-title>
                  <v-divider></v-divider>
                  <v-list dense class="pukulist">               
                    <v-list-tile>
                      <v-list-tile-content><b>{{ $t('Order Number')}}:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end"><b>#{{order.timestamp}}</b></v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content><b>{{ $t('Number Of Item')}}:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end">{{order.quantity}}</v-list-tile-content>
                    </v-list-tile>
                  
                     <v-list-tile v-if="order.checkout_total_without_vat"> 
                      <v-list-tile-content><b>Total:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end"><b>{{currency}}{{order.checkout_total_without_vat}}</b></v-list-tile-content>
                    </v-list-tile>   
                    <v-list-tile>
                      <v-list-tile-content><b>{{ $t('Total_price')}} {{ $t('Include')}} {{ $t('Vat')}}:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end"><b>{{currency}}{{order.checkout_total}}</b></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <br><br>
                 
                  <br>
                  <v-divider></v-divider>
                 
                  <v-flex  class="order_action justify-center py-2" > 
                    <v-btn @click="printData()">{{ $t('Print')}} {{ $t('This_order')}}</v-btn>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex xs12 md7>
                <v-card>
                  <v-card-title><h4>{{ $t('Cart')}} Items</h4></v-card-title>             
                  <v-divider></v-divider>
                  <v-data-table
                  :headers="headers"
                  :items="order.cart"
                  :search="search"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  row
                  wrap
                  class="elevation-1 mx-3"
                  >
                  <template slot="items" slot-scope="props">                            
                    <td class="text-xs-left"><v-img :src="props.item.product.image" aspect-ratio="1" style="width:55px;"> </v-img></td>
                    <td class="text-xs-left">{{ props.item.product.item_name }}</td>
                    <td class="text-xs-left">{{currency}}{{ props.item.product.price }}</td>
                    <td class="text-xs-left">{{ props.item.quantity }}</td>
                    <td class="text-xs-left">{{currency}}{{props.item.quantity * props.item.product.price}}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <div class="text-center"> 
              <v-snackbar
                v-model="processingSnackbar"
                :timeout="timeout"
              >
                {{ orderProcessingText }}             
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
            <div class="text-center"> 
              <v-snackbar
                v-model="completeSnackbar"
                :timeout="timeout"
              >              
                {{ orderCompleteText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
            <div class="text-center"> 
              <v-snackbar
                v-model="cancelledSnackbar"
                :timeout="timeout"
              >              
                {{ orderCancelledText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>

          </v-layout>
        </v-container>
      </v-content>
      
      <div id="printDiv" style="display:none;">
        <div>
          <h3 class="headline text-xs-center black--text">{{company_name}}</h3>              
            <h4 class="text-xs-center black--text">{{company_address}}</h4>
            <h4 class="text-xs-center black--text">{{ $t('Mobile_number')}}: {{company_mobile}}</h4>
            <div class="mt-4 py-2 pos_header_info1 d-flex">
              <v-flex xs12 text-xs-left class="px-4">
                <h5><b class="black--text">{{ $t('Customer_name')}}: {{order.name}}</b></h5>
                <h5 ><b class="black--text">{{ $t('Mobile_number')}}: {{order.phone}}</b></h5>
              </v-flex> 
              <v-flex xs12 text-xs-right class="px-4">
                <h5> <b class="black--text">{{ $t('Date')}}: {{today}}</b></h5>
              </v-flex> 
            </div>  
        </div>
        <table class="table_print mb-1">
        <tr>
          <th>{{ $t('Item_name')}}</th>
          <th>{{ $t('Quantity')}}</th>
          <th>{{ $t('Price')}}</th>
          <th>Total</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in order.cart" :key="index">         
          <td><b>{{item.product.item_name}}</b></td>
          <td><b>{{item.quantity}}</b></td>
          <td><b>{{currency}}{{item.product.price}}</b></td>
          <td><b>{{currency}}{{(item.product.price*item.quantity).toFixed(2)}}</b></td>
          <td></td>
        </tr>           
        </table>
        
        <table>
          <tr> 
            <td></td> 
            <td class="text-xs-right py-1"><b class="black--text ">{{ $t('Subtotal')}}:</b></td>
            <td class="text-xs-right py-1"><b class="black--text  pr-3">{{currency}}{{order.checkout_total_without_vat}}</b></td>
            <td></td> 
          </tr> 
          
          <tr class="for_border"> 
            <td></td> 
            <td class="text-xs-right py-1"><b class="black--text ">{{ $t('Grand')}} {{ $t('Total')}} ( {{ $t('Include')}} {{this.vat}}% {{ $t('Vat')}} ):</b></td>
            <td class="text-xs-right py-1"><b class="black--text  pr-3">{{currency}}{{order.checkout_total}}</b></td>
            <td></td>
          </tr>
        </table>
        
        <div class="mt-4">
          <h4 class="text-xs-center black--text text-uppercase">{{ $t('Thank_u')}}</h4>
          <h4 class="text-xs-center black--text text-uppercase">{{ $t('Come_again')}}</h4>
          <br><br><br><br>
        </div>
      </div>

    </div>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from "firebase";
  import moment from 'moment'
  export default {
    name:'ViewOrder',
    components: {
      Navbar
    },
    data(){
      return{
        today:moment().format('DD-MM-YYYY'),
        rowsPerPageItems: [8, 16, 24],
        pagination: {
        rowsPerPage: 8
        },
        vat:null,     
        order:[],      
        current_month_name:moment().format('MMMM'),
        current_year:moment().format('YYYY'),    
        currency:'',
        company_name:'',        
        company_address:'',        
        company_mobile:'',
        /*headers: [                
          { text: 'Image' , value: 'image', sortable: !1 },  
          { text: 'Product' , value: 'item_name', sortable: !1 },  
          { text: 'Price' , value: 'price', sortable: !1 },
          { text: 'Quantity' , value: 'quantity', sortable: !1 },
          { text: 'Total' , value: 'timestamp', sortable: !1 },                                         
        ],*/
        search:'',
        order_status:null,
        snackbar:false,
        processingSnackbar: false,
        completeSnackbar: false,
        cancelledSnackbar: false,
        orderProcessingText: 'Oder is processing for delivery',
        orderCompleteText: 'Oder completed successfully',
        orderCancelledText: 'Oder cancelled',
        timeout: 3000,
        deliveryPerson:[],
        delivery_person_name:this.delivery_person_name,
        date:this.date,
        time:this.time,
        menu1: false,
        menu3: false,     
        delivery:[],       
      }
    },
    methods:{   
      orderProcessing(id){       
        var db = firebase.firestore(); 
        // Change order status
        let orderRef = db.collection('orders').doc(this.$route.params.id);
          orderRef.update({            
            order_status:"Processing"          
        })
        // Order processing for delivery 
        if(this.delivery_person_name && this.date && this.time){
        let deliveryRef = db.collection('deliveries').doc(this.$route.params.id);
        deliveryRef.set({
          id:this.$route.params.id,
          order_id:this.order.timestamp,
          delivery_person_name:this.delivery_person_name,
          date:this.date,
          time:this.time,
          delivery_status:"Processing",
          duration:60,      
          created_date:moment().format('DD-MM-YYYY'),
          created_month:moment().format('MM-YYYY'),
          timestamp:Date.now()
        })
        this.delivery_person_name=null
        this.date=null
        this.time=null
        }
        this.processingSnackbar = true    
      },
      orderComplete(id){       
        var db = firebase.firestore(); 
        let ref = db.collection('orders').doc(this.$route.params.id);
          ref.update({            
            order_status:"Complete",
            created_date:moment().format('DD-MM-YYYY'),
            created_month:moment().format('MM-YYYY'),               
            created_year:moment().format('YYYY'),                    
        })
        let deliveryRef = db.collection('deliveries').doc(id);
            deliveryRef.update({            
            delivery_status:"Complete"          
        })
        
        this.completeSnackbar = true    
      },
      orderCancelled(id){       
        var db = firebase.firestore(); 
        let ref = db.collection('orders').doc(this.$route.params.id);
          ref.update({            
            order_status:"Cancelled"          
        }) 
        this.cancelledSnackbar = true    
      },
      printData(){ 
        var backup = document.body.innerHTML;
        var divContent = document.getElementById("printDiv").innerHTML;
        document.body.innerHTML = divContent;
        window.print();
        document.body.innerHTML = backup;       
      },
    },
    created(){
      var db = firebase.firestore(); 

      // Current Currency
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })

      // Current Vat
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.vat = doc.data().vat
      })
      
      // Company Name
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.company_name = doc.data().company_name
      })
      
      // Company Address
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.company_address = doc.data().company_address
      })

      // Company Mobile
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.company_mobile = doc.data().company_mobile
      })

      // Show data of a specific Order
      var db = firebase.firestore(); 
      db.collection("orders").doc(this.$route.params.id).onSnapshot(doc =>{
        this.order = doc.data()
        this.order.id = doc.id
      })
      
      // Show All Delivery Person
      let ref = db.collection('delivery_person').orderBy('timestamp', 'desc')      
      ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc
            this.deliveryPerson.push({
              id:doc.id,
              name:doc.data().name
            })
          }
        })
      }) 
      // Delivery details
      db.collection("deliveries").doc(this.$route.params.id).onSnapshot(doc =>{
        this.delivery = doc.data()      
      })
    },
    computed:{
      headers () {
      return [
        {
          text: this.$t('Image'),
          align: 'left',
          sortable: false,
          value: 'image'
        },
        {
          text: this.$t('Products'),
          align: 'left',
          sortable: false,
          value: 'item_name'
        },
        {
          text: this.$t('Price'),
          align: 'left',
          sortable: false,
          value: 'price'
        },
        {
          text: this.$t('Quantity'),
          align: 'left',
          sortable: false,
          value: 'quantity'
        },
        
        
        
        {
          text: this.$t('Total'),
          align: 'left',
          sortable: false,
          value: 'timestamp'
        },
        
      ]
     },
      
      
     
         
    },
  }
</script>

<style scoped>
  .view_order .elevation-1{
    margin:0!important;
  }
  tbody a{
    font-size: 13px;
    color:black;
    text-decoration: underline;
  }
  h1{
    width: 100%;
  }
  h4{
    width: 100%;
  }
  .updates-heading{
    margin-left: 25px;
  }
  light.divider, .theme--light .divider {
    background-color: rgba(0,0,0,.12);
  }
  .monthy_total{
    float: right;
    margin-left: 50px;
  }
  .order_action{
    width:100%;
    display:flex;
    text-align: center;
  }
  .primary--text {
    color: #E7272D !important;
    caret-color: #E7272D !important;
}

 .v-picker__title.primary{
    background-color: #F16D07 !important;
    border-color: #F16D07 !important;
}

  @media (max-width:346px){
    .order_action{
      width:100%;
      display:grid;
      text-align: center;
    }
    .v-btn {
      height: 36px;
      font-size: 14px;
      font-weight: 500;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin: 6px 8px;
      min-width: 100%!important;
    }
  }
  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #F16D07 !important;
    border-color: #F16D07 !important;
  }

  /* Print Table */ 
  table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
td:last-of-type{
  width:10px;
}
.table_print td:last-child{
  width:30px!important;
}
.table_print td,.table_print th {
  border: 1px dashed #212121;
  text-align: right;
  padding: 8px;
}

.table_print tr:nth-child(even) {
  background-color: #dddddd;
}
.for_border{
  border-top:1px dashed #212121;
}

  .pos_sub_total .flex{
    text-align: right;
  }
  .pos_gap{
    padding:0!important;
  }
   .pos_button{
    text-align: center;
  }
   .pos_button .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: #F16D07;
    color:#FAFAFA;
    text-transform: capitalize;
  }
  .pos_print{
    position: relative; 
  }
  .pos_header_info{
    border-bottom:1px dashed rgb(0,0,0,0.87);
    border-top:1px dashed rgb(0,0,0,0.87);
  }
  .pos_header_info1{
    border-bottom:0px dashed rgb(0,0,0,0.87);
    border-top:1px dashed rgb(0,0,0,0.87);
  }
  #printDiv{
    padding:8px 15px!important;
    width:300px;
  }
 .table_total  td[data-v-7fcf83bf] {
    border: 0px solid #212121!important;
    
    padding: 8px;
}
  #printDiv .pos_machine_sub_total_border_2{
    border-top: 1px solid rgba(0,0,0,.22);
  }
  #printDiv .pos_machine_sub_total .flex.xs6[data-v-7fcf83bf] {
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 50%;
    text-align: right;
}
#printDiv .pos_machine_sub_total_border_2 .flex.xs6[data-v-7fcf83bf] {
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 50%;
    text-align: right;
    margin-right: 11px;
    color: rgb(0,0,0,0.87);
    font-weight: bold;
    padding: 8px 0 8px 8px!important;
}

#printDiv .v-list{
  padding:0!important;
}

  .pos_machine_sub_total .pos_sub_total {
    color:rgb(0,0,0,0.87);
  }
  .pos_sub_total .v-list__tile {
    padding: 0!important;
  }
  .pos_machine_sub_total .v-list__tile__content[data-v-bb4665ce] {
    padding: 2px 0;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
    color: rgb(0,0,0,0.87);
    font-weight: bold;
}
  .pos_machine_sub_total .v-list__tile__content {
    padding: 2px 0;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items:flex-end;
  }
  .pos_machine_sub_total .flex.xs6 {
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 50%;
    text-align: right;
    color: rgb(0,0,0,0.87);
    font-weight: bold;
    padding:8px 0 8px 8px!important;
}

 .pos_table .v-table tbody td:nth-of-type(1){
   width: 120px;
 }
.pos_machine_sub_total_border::before{
  content:'';
  position: absolute;
  height:0px;
  width:50%;
  right:40px;
  margin-top: -8px;
  border-top: 1px solid rgba(0,0,0,.22);
}

.check_out_pos{
  display:flex;
}
.check_out_pos .pos_button:nth-of-type(1){
  margin-right:10px;
}
@media screen and (max-width: 767px) {
  .check_out_pos{
  display:grid;
}
.check_out_pos .pos_button:nth-of-type(1){
  margin-right:0px;
}
}
 

</style>



// WEBPACK FOOTER //
// src/components/admin/sales/ViewOrder.vue